import { create } from "zustand";

type Route = {
  path: string;
};
type NavigationState = {
  routes: Route[];
  pushRoute: (route: Route) => void;
  dataByPath: Record<string, unknown>;
  setData: (path: string, data: unknown) => void;
  optionsByPath: Record<string, unknown>;
  setOptions: (path: string, options: unknown) => void;
};

export const useNavigationStore = create<NavigationState>((set) => ({
  dataByPath: {},
  optionsByPath: {},
  routes: [],
  pushRoute: (route) =>
    set((s) => {
      const last = s.routes.at(-1);
      if (last?.path === route.path) return s;
      return { routes: [...s.routes, route] };
    }),
  setData: (path, data) =>
    set((s) => ({ dataByPath: { ...s.dataByPath, [path]: data } })),
  setOptions: (path, options) =>
    set((s) => ({ optionsByPath: { ...s.optionsByPath, [path]: options } })),
}));
